import React from "react";
import { SubmenuTitle } from "../components/SubmenuTitle";
import pic from "../../assets/images/tempshow.png";
import { PictureText } from "../components/PictureText";
import { getShowings, getShowingYears } from "../../apis/api";
import { pageInfo, ShowInfo } from "../../models/system";
import Item from "antd/lib/list/Item";


export class Temp extends React.Component {
    state = { infos: null as pageInfo<ShowInfo> | null, curpage: 0 as number, year: new Date().getFullYear(), yearlist: [] as number[] }
    componentDidMount(): void {
        getShowings(1, 0, 10, this.state.year).then((data) => {
            this.setState({ infos: data });

        });
        getShowingYears(1, 5).then((data) => {
            this.setState({ yearlist: data });
        });
        document.querySelector("#temp_more")?.addEventListener("click", () => {

            if (this.state.infos!.content.length <= this.state.infos!.pageCount) {
                this.setState({ curpage: this.state.curpage + 1 })
                getShowings(1, this.state.curpage, 10, this.state.year).then((data) => {
                    let c = this.state.infos!.content;
                    this.state.infos!.content = [...this.state.infos!.content, ...data.content];

                    this.forceUpdate();
                });
            }
        })
        // document.querySelector(".time_axis")?.addEventListener("click", (e) => {
        //     let target = e.target as HTMLElement;
        //     if (target.tagName == "DIV") {
        //         let index = Array.from(target.parentElement!.children).indexOf(target);
        //         if (index > 0) {
        //             let divs = document.querySelectorAll(".time_axis .axis div");
        //             divs.forEach((item) => {
        //                 item.classList.remove("choiced");
        //             })
        //             target.classList.add("choiced");
        //             getShowings(1, index - 1, 10).then((data) => {
        //                 this.setState({ infos: data });
        //                 this.forceUpdate();
        //             });
        //         }
        //     }
        // });

        document.querySelector(".axis")?.addEventListener("click", (e) => {

            let target = e.target as HTMLElement;

            if (target.tagName == "DIV") {
                let index = Array.from(target.parentElement!.children).indexOf(target);
                let divs = document.querySelectorAll(".time_axis .axis div");
                divs.forEach((item) => {
                    item.classList.remove("choiced");
                })

                target.classList.add("choiced");
                this.setState({ year: target.innerText == "当前展览" ? new Date().getFullYear() : target.innerText, curpage: 0 }, () => {
                    ;
                    getShowings(1, this.state.curpage, 10, this.state.year).then((data) => {
                        this.setState({ infos: data });
                        this.forceUpdate();
                    })
                });
            }
        });
    }
    render(): React.ReactNode {
        return (
            <>
                <div className="temp">

                    {/* <div className="visitnum">浏览次数：{this.state.infos?.hitCounts}</div> */}
                    <div className="time_axis">
                        <div className="hr"></div>
                        <div className="axis">
                            <div className="choiced" >当前展览</div>
                            {
                                this.state.yearlist.map((item, index) => <div key={index}>{item}</div>)

                            }


                        </div>
                    </div>



                    {
                        this.state.infos?.content?.map((item, index) =>
                            <PictureText className="tw" title={item.title} address={"展览地点：" + item.address} time={"展览时间：" + item.date} picture={item.pic} content={"展览内容：" + item.desc}></PictureText>)
                    }



                    <div id="temp_more" className="btn">更多</div>
                </div>
            </>
        )
    }
}


